import { AnyAction, combineReducers, Reducer } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

import { persistReducer } from "redux-persist";

import requirementList from "./ducks/requirementList";
import planningAndScheduling from "./ducks/planningAndScheduling";
import processEngineering from "./ducks/processEngineering";
import departmentEvaluations from "./ducks/departmentEvaluations";
import attachments from "./ducks/attachments/slice";
import feedStockTradingFeedback from "./ducks/feedStockTradingFeedback";
import originsReducer from "./ducks/origins";
import systemsReducer from "./ducks/systems";
import requirementDetailsReducer from "./ducks/requirementDetails";
import clusterGraphReducer from "./ducks/clusterGraph";
import countriesReducer from "./ducks/countries";
import recommendations from "./ducks/recommendations";
import componentsReport from "./ducks/componentsReport";
import componentsListing from "./ducks/componentsListing";
import clusterInfo from "./ducks/clusterInfo";
import OCR from "./ducks/OCR";
import historicalMeans from "./ducks/historicalMeans";
import products from "./ducks/products";
import ports from "./ducks/ports";
import capabilityAnalysis from "./ducks/capabilityAnalysis";
import users from "./ducks/users";
import components from "./ducks/components";
import rawMaterials from "./ducks/rawMaterials";
import { iffApi } from "../services/api";

import { RootState } from ".";

const persistRecommenadtionConfig = {
  key: "Recommendations",
  storage,
  whitelist: ["cachedRecommendations", "selectedSystemRecommendations"],
};

const persistedRecommendations = persistReducer(
  persistRecommenadtionConfig,
  recommendations,
);

const persistComponentsReportConfig = {
  key: "ComponentsReport",
  storage,
  whitelist: ["formInitialValues"],
};

const persistedComponentsReport = persistReducer(
  persistComponentsReportConfig,
  componentsReport,
);

const persistClusterInfoConfig = {
  key: "ClusterInfo",
  storage,
};

const persistedClusterInfo = persistReducer(
  persistClusterInfoConfig,
  clusterInfo,
);

const persistOCRResultsConfig = {
  key: "OCRResults",
  storage, 
  whitelist: ["OCRResults"]
};

const persistedOCRResults = persistReducer(persistOCRResultsConfig, OCR);

const combinedReducer = combineReducers({
  origins: originsReducer,
  requirementList,
  attachments,
  planningAndScheduling,
  processEngineering,
  feedStockTradingFeedback,
  systems: systemsReducer,
  requirementDetails: requirementDetailsReducer,
  clusterGraph: clusterGraphReducer,
  countries: countriesReducer,
  recommendations: persistedRecommendations,
  componentsReport: persistedComponentsReport,
  componentsListing,
  clusterInfo: persistedClusterInfo,
  OCR: persistedOCRResults,
  historicalMeans,
  departmentEvaluations,
  products,
  ports,
  components,
  rawMaterials,
  [iffApi.reducerPath]: iffApi.reducer,
  capabilityAnalysis,
  users
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === "componentsReport/clearForm") {
    storage.removeItem("persist:ComponentsReport");
  }

  if (action.type === "recommendations/clearRecommendations") {
    storage.removeItem("persist:Recommendations");
  }

  if (action.type === "clusterInfo/clearClusterInfo") {
    storage.removeItem("persist:ClusterInfo");
  }

  if(action.type === "OCR/resetOCRResults") {
    storage.removeItem("persist:OCRResults");
  }

  return combinedReducer(state, action);
};

export default rootReducer;
